// File constants.js is saved on Bitwraden with name: constants - Jovem do Ano FRONT PROD
export const API_BASE_URL = "https://api-jovemdoano.draft5.gg";
// export const API_BASE_URL = "http://localhost:3012";
export const recaptchaKey = "6Lc9pTMsAAAAAD76qlefCU5_urhKmqJk51X_P0dT";
export const DATE_VOTE_FINISHED = "2026-01-16T02:59:00Z";
export const VOTE_YEAR = 2025;
export const PLAYER_WINNER = "João Vinicius";
export const PLAYER_WINNER_NICK = "snow";
export const PLAYER_WINNER_TEAM = "paiN Gaming";
export const PLAYER_WINNER_LINK =
  "https://draft5.gg/noticia/snow-e-o-vencedor-do-premio-matheus-brutt-queiroz-de-jovem-do-ano-2025";
